"use client";
// src/components/Icons/Windows.svg
var Windows_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgZmlsbD0ibm9uZSI+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBmaWxsPSIjMDA3OEQ0IiBkPSJNMCAwaDIyLjc1NXYyMi43NDVIMFYwWm0yNS4yNDUgMEg0OHYyMi43NDVIMjUuMjQ1VjBaTTAgMjUuMjQ1aDIyLjc1NVY0OEgwVjI1LjI0NVptMjUuMjQ1IDBINDhWNDhIMjUuMjQ1Ii8+PC9nPjxkZWZzPjxjbGlwUGF0aCBpZD0iYSI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMGg0OHY0OEgweiIvPjwvY2xpcFBhdGg+PC9kZWZzPjwvc3ZnPg==";
export {
  Windows_default as default
};
